<template>
  <!-- 流程管理-列表 -->
  <div>
    <div class="wrap">
      <r-pointer :textName="`${ $t('process.proManage') }`" />
      <!-- 搜索 -->
      <r-search class="p_search" @on-blur="getCommValue" @on-search="commSearch(1)">
        <a-button type="primary" slot="btn" @click="visibleModal = true">{{ $t('process.upload') }}</a-button>
        <div slot="senior" id="search_form">
          <a-form @submit="handleSearch" class="senior_form" layout="inline">
            <a-row type="flex">
              <a-col :span="8">
                <a-form-item :label="`${ $t('formAbout.proName') }`" :label-col="labelCol" :wrapper-col="wrapperCol">
                  <a-input v-model="senParams.procName" style="width:100%;"/>
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item :label="`${ $t('formAbout.taskStatus') }`" :label-col="labelCol" :wrapper-col="wrapperCol">
                  <a-select v-model="senParams.status" style="width:100%;">
                    <a-select-option v-for="(item, index) in statusOptions" :key="index" :value="item.value"> {{ item.label }} </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item :label="`${ $t('formAbout.desc') }`" :label-col="labelCol" :wrapper-col="wrapperCol">
                  <a-input v-model="senParams.procDesc" style="width:100%;"/>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row type="flex">
              <a-col :span="8">
                <a-form-item :label="`${ $t('formAbout.pushTime') }`" :label-col="labelCol" :wrapper-col="wrapperCol">
                  <a-range-picker @change="onCreatedChange" v-model="dateRange" style="width:100%"/>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row type="flex" :gutter="12">
              <a-col :span="2"></a-col>
              <a-col :span="6" class="btn_gruop">
                <a-button type="primary" html-type="submit" :loading="searchLoading"> {{ $t('formAbout.searchBtn') }} </a-button>
                <a-button :style="{ marginLeft: '8px' }" @click="handleReset" > {{ $t('formAbout.clear') }} </a-button>
              </a-col>
            </a-row>
          </a-form>
        </div>
      </r-search>
      <!-- 列表数据 -->
      <a-table :columns="columns" :dataSource="dataList" :loading="tabLoading" :pagination="pagination" rowKey="id">
        <!-- 流程名 -->
        <span slot="name" slot-scope="text, record">
          <template>
            <div>
              <p>{{ record.procName }}</p>
              <p>{{ $t('task.publish') }}：{{ record.publishTime || '-' }}</p>
              <p>{{ $t('task.version') }}：{{ record.procVer || '-' }}</p>
            </div>
          </template>
        </span>
        <!-- 状态 -->
        <span slot="status" slot-scope="text">
          <template>
            <div class="r_status" v-if="text == 'disable'">
              <i class="iconfont iconjinyong out"></i>
              <span>{{ $t('process.disable') }}</span>
            </div>
            <div class="r_status" v-else>
              <i class="iconfont iconqiyong ing"></i>
              <span>{{ $t('process.enable') }}</span>
            </div>
          </template>
        </span>
        <!-- 机器人范围 -->
        <span slot="range" slot-scope="text">
          <template>
            <div v-if="text.substring(0, 1) != '['">{{ $t('process.allRobot') }}</div>
            <div v-else>
              <div v-if="robotList(text).length">
                <span v-for="(item, index) in robotList(text)" :key="index" >
                  <span v-if="index < 3">{{ item }}</span>
                </span>
                <div class="lenStr" v-if="robotList(text).length > 3">... {{ $t('process.total') }}{{ robotList(text).length }}{{ $t('process.robotDetail') }}</div>
              </div>
              <div v-else>-</div>
            </div>
          </template>
        </span>
        <!-- 调度 -->
        <span slot="info" slot-scope="record">
          <template>
            <!-- 定时 -->
            <div v-if="record.procRunMode === 'time'">
              <div v-if="record.scheduleList && record.scheduleList.length">
                <div v-for="(item, index) in record.scheduleList" :key="index" >
                  <p v-if="index < 3">{{ item.scheduleExpreDesc }}</p>
                </div>
                <span class="lenStr" v-if="record.scheduleList.length > 3">... {{ $t('process.total') }}{{ record.scheduleList.length }}{{ $t('process.schDetail') }}</span>
              </div>
              <div v-else>-</div>
            </div>
            <div v-else>
              {{ record.procRunMode === 'startup' ? `${ $t('proConfig.modeArr[1]') }` : `${ $t('proConfig.modeArr[2]') }` }}
            </div>
          </template>
        </span>
        <!-- 操作 -->
        <span slot="action" slot-scope="text, record, index">
          <template>
            <div class="execute-btn">
              <a-button size="small" @click="tempTask(record, index)" :loading="tempLoadingArr[index]">{{ $t('operation.executeImmediately') }}</a-button>
            </div>
            <div>
              <a @click="$router.push(`/set?id=${record.id}`)">{{ $t('operation.editBtn') }}</a>
              <a-divider type="vertical" />
              <a @click="$router.push(`/task?pro_code=${record.procCode}`)">{{ $t('operation.task') }}</a>
            </div>
            <div>
              <a @click="changeProcessStatus(record.id, record.status)">{{ record.status === 'disable' ? `${ $t('process.enable') }` : `${ $t('process.disable') }` }}</a>
              <a-divider type="vertical" />
              <a @click="handleDelete(record.id)">{{ $t('operation.btnDel') }}</a>
            </div>
          </template>
        </span>
      </a-table>
    </div>
    <input type="file" ref="uploadInput" @change="chooseFile" style="opacity: 0;" accept=".ipkg"/>
    <!-- 上传弹框 -->
    <a-modal
      :title="`${ $t('process.upload') }`"
      v-model="visibleModal"
      :confirmLoading="uploadLoading"
      :okText="`${ $t('process.saveOrSet') }`"
      @cancel="cancelOptions"
      @ok="handleUpload" >
      <a-form layout="inline">
        <a-form-item :label="`${ $t('process.file') }`" required>
          <a-button style="width:300px;" @click="$refs.uploadInput.click()">{{ fileName }}</a-button>
          <i class="iconfont iconwenjianjia file_icon" @click="$refs.uploadInput.click()"></i>
          <div v-if="showTip" style="color:red;line-height:20px;">{{ $t('process.ipkg') }}</div>
        </a-form-item>
        <a-form-item :label="`${ $t('formAbout.desc') }`" style="margin-left: 10px;">
          <a-textarea v-model="desc" style="width:300px;" />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { apiProcess } from '@/api/process'
import { modalTip } from '@/utils/tipTools'

export default {
  data () {
    return {
      dateRange: [],
      // 搜索load
      searchLoading: false,
      // 状态下拉
      statusOptions: [
        { value: '', label: this.$t('robotDes.allStatus') },
        { value: 'enable', label: this.$t('process.enable') },
        { value: 'disable', label: this.$t('process.disable') }
      ],
      // 表格表头
      columns: [
        {
          title: this.$t('process.proName'),
          key: 'name',
          scopedSlots: { customRender: 'name' }
        },
        {
          title: this.$t('process.runStatus'),
          dataIndex: 'status',
          width: '90px',
          scopedSlots: { customRender: 'status' }
        },
        {
          title: this.$t('process.robotRange'),
          key: 'range',
          dataIndex: 'execRobotsNo',
          scopedSlots: { customRender: 'range' }
        },
        {
          title: this.$t('process.schedule'),
          key: 'info',
          scopedSlots: { customRender: 'info' }
        },
        // {
        //   title: this.$t('process.taskTime'),
        //   dataIndex: 'nextExeTime'
        // },
        {
          title: this.$t('operation.tableOperation'),
          key: 'operation',
          align: 'center',
          width: '15%',
          scopedSlots: { customRender: 'action' }
        }
      ],
      labelCol: { span: 6 },
      wrapperCol: { span: 16 },
      // 搜索入参
      senParams: {
        searchContent: '',
        procName: '',
        procDesc: '',
        publishStartTime: '',
        publishEndTime: '',
        status: ''
      },
      // 列表Load
      tabLoading: false,
      // 列表数据
      dataList: [],
      // 分页
      pagination: {
        showQuickJumper: true,
        current: 1,
        pageSize: 10,
        total: 0,
        size: 'samll',
        showSizeChanger: true, // 可以改变 pageSize
        showTotal: total => `${this.$t('operation.total')} ${total} ${this.$t('operation.items')}，`,
        onChange: this.commSearch,
        onShowSizeChange: this.commSearch
      },
      // 立即执行按钮loading
      tempLoadingArr: [],
      // 上传弹框
      visibleModal: false,
      // 上传load
      uploadLoading: false,
      fileIPKG: '',
      fileName: '',
      showTip: false,
      desc: ''
    }
  },
  created () {
    this._fetchList()
  },
  methods: {
    robotList (text) {
      const list = text.substring(0, text.length - 1).substring(1).split(',').filter(item => {
        return item
      })
      return list
    },
    /**
     * 获取机器人列表数据
     */
    _fetchList () {
      this.tabLoading = true
      apiProcess.list(this.senParams, this.pagination.current, this.pagination.pageSize).then(data => {
        this.tabLoading = false
        this.searchLoading = false
        this.dataList = data.items
        // 每条记录加一个对应的 立即执行的状态loading
        for (let i = 0; i < this.dataList.length; i++) {
          this.tempLoadingArr.push(false)
        }
        this.pagination.total = data.total
      })
    },
    /**
     * 获取普通搜索值
     */
    getCommValue (searchValue) {
      this.senParams.searchContent = searchValue
    },
    /**
     * 普通搜索
     */
    commSearch (page, size) {
      this.pagination.current = page
      if (size) {
        this.pagination.pageSize = size
      }
      this._fetchList()
    },
    /**
     * 创建时间
     */
    onCreatedChange (date, dateArr) {
      this.senParams.publishStartTime = dateArr[0]
      this.senParams.publishEndTime = dateArr[1]
    },
    /**
     * 高级搜索
     */
    handleSearch  (e) {
      e.preventDefault()
      this.pagination.current = 1
      this.searchLoading = true
      this._fetchList()
    },
    /**
     * 高级搜索表单清空
     */
    handleReset () {
      this.dateRange = []
      Object.keys(this.senParams).forEach(item => {
        this.senParams[item] = ''
      })
    },
    /**
     * 修改流程状态
     */
    changeProcessStatus (id, status) {
      const _this = this
      const newStatus = status === 'disable' ? 'enable' : 'disable'
      this.$confirm({
        title: this.$t('operation.tip'),
        content: `${status === 'disable' ? this.$t('process.isEnable') : this.$t('process.isDisable')}`,
        onOk () {
          return new Promise((resolve, reject) => {
            apiProcess.updateStatus(id, newStatus).then(data => {
              _this.$message.success(_this.$t('msg.proStateSucess'))
              _this._fetchList()
              resolve()
            }).catch(err => {
              resolve(err)
            })
          })
        }
      })
    },
    /**
     * 删除流程
     */
    handleDelete (id) {
      const _this = this
      this.$confirm({
        title: this.$t('operation.tip'),
        content: this.$t('process.delTip'),
        okText: this.$t('operation.ok'),
        okType: 'danger',
        cancelText: this.$t('operation.cancel'),
        onOk () {
          return new Promise((resolve, reject) => {
            apiProcess.delete(id).then(data => {
              _this.$message.success(_this.$t('msg.delSuceess'))
              _this.commSearch(1)
              resolve('ok')
            }).catch(err => {
              resolve(err)
            })
          })
        }
      })
    },
    /**
     * 选择文件
     */
    chooseFile () {
      this.fileIPKG = this.$refs.uploadInput.files[0]
      this.fileName = this.fileIPKG.name
      this.showTip = false
      console.log(this.fileIPKG)
    },
    /**
     * 上传
     */
    handleUpload (e) {
      e.preventDefault()
      if (!this.fileIPKG) {
        this.showTip = true
        return
      }
      this.uploadLoading = true
      const formData = new FormData()
      formData.append('procPack', this.fileIPKG)
      formData.append('procDesc', this.desc)
      apiProcess.upload(formData).then(data => {
        this.commSearch(1)
        this.uploadLoading = false
        this.$message.success(this.$t('msg.uploadSucess'))
        this.cancelOptions()
        this.$router.push(`/set?id=${data.id}`)
      }).catch(() => {
        this.uploadLoading = false
      })
    },
    /**
     * 上传取消
     */
    cancelOptions () {
      this.$refs.uploadInput.value = ''
      this.desc = ''
      this.fileName = ''
      this.fileIPKG = ''
      this.showTip = false
      this.visibleModal = false
    },
    // 调整execRobotsNo入参格式
    setExecRobotsNo (execRobotsNo) {
      if (execRobotsNo.substring(0, 1) !== '[') {
        return 'all'
      } else {
        return this.robotList(execRobotsNo).join(',')
      }
    },
    /**
     * 立即执行，等同于编辑中的‘临时任务’
     */
    tempTask (record, index) {
      // console.log(index)
      // console.log(record)
      const par = {
        id: record.id,
        procName: record.procName,
        procCode: record.procCode,
        procFile: record.procFile,
        procVer: record.procVer || '',
        procHandDurationMin: record.procHandDurationMin || '',
        execRobotsNo: this.setExecRobotsNo(record.execRobotsNo) || ''
      }
      // console.log(par)
      // 询问是否立即执行
      modalTip(
        'confirm',
        `${this.$t('operation.whetherExecuteImm')}`,
        () => {
          // this.$set html与data保持同步
          this.$set(this.tempLoadingArr, index, true)
          apiProcess.temp(par).then(data => {
            this.$message.success(this.$t('proConfig.tempStart'))
            this.$set(this.tempLoadingArr, index, false)
          }).catch(() => {
            this.$set(this.tempLoadingArr, index, false)
          })
        }
      )
    }
  }
}
</script>

<style lang="less" scoped>
.wrap {
  padding: 0 24px 12px 12px;
  background: #fff;
  .p_search {
    margin: 9px 0;
  }
  .r_status {
    i {
      margin-right: 12px;
    }
    .ing {
      color: #52C41A;
    }
    .out {
      color: #F5222D;
    }
  }
  .lenStr {
    color: #a2a2a2;
    font-size: 12px;
    margin-top: 5px;
  }
  .btn_group {
    margin-top: 20px;
    button {
      margin-right: 10px;
    }
  }
}
.file_icon {
  cursor: pointer;
  color: #4977FC;
  margin-left: 10px;
}
.execute-btn {
  // padding-top: 9px;
  >button {
    border: 0;
    background-color: transparent;
    color: #1890ff!important;
    box-shadow: none;
  }
}
</style>
